import * as types from './action-types';

export const resize = width => ({
    type: types.RESIZE,
    width
});



// WEBPACK FOOTER //
// ./src/actions/viewport.js